<template>
  <div class="dashbase">
    <div class="dashheader">
      <a-row :gutter="18">
        <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '24px' }">
          <AreaChartCard
            ref="vistAreaChart"
            :loading="loading"
            :title="$t('charts.totalViews')"
            :chartTips="$t('charts.totalViews')"
            :total="vistChartData.total"
            :rightTitle="$t('charts.dayViews')"
            :rightNum="vistChartData.today"
            theme="#ea4856"
            uniqueId="areacontainer1"
          ></AreaChartCard>
        </a-col>
        <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '24px' }">
          <AreaChartCard
            ref="pubAreaChart"
            :loading="loading"
            :title="$t('charts.publishTitle')"
            :chartTips="$t('charts.publishTitle')"
            :total="pubChartData.total"
            :rightTitle="$t('charts.dailyRelease')"
            :rightNum="pubChartData.toady"
            uniqueId="areacontainer2"
            xField="stat_date"
            yField="work_count"
            :yAlias="$t('charts.release')"
          ></AreaChartCard>
        </a-col>
        <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '24px' }">
          <ColChartCard
            ref="colChart"
            :loading="loading"
            :title="$t('charts.userCre')"
            :chartTips="$t('charts.userCre')"
            :total="userChartData.newusers"
            :rightTitle="$t('charts.userPersient')"
            :rightNum="userChartData.addCount"
          ></ColChartCard>
        </a-col>
      </a-row>
    </div>
  <!--  
    <div class="dashbottom" v-if="userInfo.store_id == ''">
      <Map></Map>
    </div>
  -->
  </div>
</template>

<script>
import ColChartCard from "@/components/Charts/ColChartCard";
import AreaChartCard from "@/components/Charts/AreaChartCard";
import Map from "@/components/Charts/Map";
import {
  getVisitDateStatist,
  getWorkDateStatist,
  getUserAddStatist,
} from "@/api/statistic";
import {mapState} from "vuex";

export default {
  components: { Map, ColChartCard, AreaChartCard },
  data() {
    return {
      loading: false,
      vistChartData: {
        total: 0,
        today: 0,
      },
      pubChartData: {
        total: 0,
        today: 0,
      },
      userChartData: {
        newusers: 0,
        addCount: 0,
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    console.log("this.userinfo",this.userInfo);
    // 訪問量
    getVisitDateStatist()
      .then((res) => {
        const data = res.data;
        if (data.statistics_data) {
          this.vistChartData.total = data.total_count;
          this.vistChartData.today = data.today_count;
          this.updateChartsData(data.statistics_data, "vist");
        }
      })
      .catch((err) => {
        // this.$message.error(err);
      });
    // 作品
    getWorkDateStatist()
      .then((res) => {
        const data = res.data;
        if (data.statistics_data) {
          this.pubChartData.total = data.total_count;
          this.pubChartData.today = data.today_count;
          this.updateChartsData(data.statistics_data, "publish");
        }
      })
      .catch((err) => {
        // this.$message.error(err);
      });
    //用戶增長
    getUserAddStatist().then((res) => {
      const data = res.data;
      if (data.user_data) {
        this.userChartData.newusers = data.total_count;
        this.userChartData.addCount = data.increase_count;
        this.updateChartsData(data.user_data, "user");
      }
    });
  },
  methods: {
    updateChartsData(data, type) {
      if (type === "vist") {
        this.$refs.vistAreaChart.update(data);
      } else if (type === "map") {
        this.$refs.mapChart.updateMapData(data);
      } else if (type === "publish") {
        this.$refs.pubAreaChart.update(data);
      } else if (type === "user") {
        this.$refs.colChart.update(data);
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.dashbase {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.dashheader {
  flex: 0 0 190px;
}
.dashbottom {
  /* flex: 0 0 800px;*/
  background-color: white;
  width: 100%;
  /*height: 900px;*/
  overflow: hidden;
}
</style>
